jQuery_T4NT(document).ready(function($) {
    console.log("Document ready, initializing Flickity...");

    // Initialize Flickity slider on document ready
    var $slider = $('.flickityt4s-slider');

    if ($slider.length > 0) {
        console.log("Flickity slider found, initializing...");
        $slider.flickity({
            cellAlign: 'left',
            contain: true,
            percentPosition: true,
            imagesLoaded: true,
            wrapAround: false,
            groupCells: '80%' // Group cells to show part of the next image
        });

        // Check if Flickity is initialized
        var flkty = Flickity.data('.flickityt4s-slider');
        if (flkty) {
            console.log("Flickity initialized successfully.");
        } else {
            console.log("Failed to initialize Flickity.");
        }
    } else {
        console.log("Flickity slider not found.");
    }
});
